import { useEffect, useState } from "react";
import { fetchLocalizedPrices, type LocalizedPriceMap } from "@/lib/stripe-prices";

/**
 * React hook wrapper around fetchLocalizedPrices (Stripe catalog lookup_keys).
 * Returns `null` while loading or on failure — callers should render a
 * hardcoded SEK fallback in that case.
 */
export function useLocalizedPrices(lookupKeys: string[]): LocalizedPriceMap | null {
  const key = lookupKeys.join("|");
  const [map, setMap] = useState<LocalizedPriceMap | null>(null);

  useEffect(() => {
    // Stripe's lookup_keys list must be non-empty — skip the round-trip.
    if (!key) {
      setMap(null);
      return;
    }
    let cancelled = false;
    fetchLocalizedPrices(lookupKeys).then((result) => {
      if (!cancelled) setMap(result);
    });
    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key]);


  return map;
}
